export enum BusinessActionTypes {
    BUSINESS_LIST = '@@business/BUSINESS_LIST',
    BUSINESS_LIST_SUCCESS = '@@business/BUSINESS_LIST_SUCCESS',
    BUSINESS_LIST_ERROR = '@@business/BUSINESS_LIST_ERROR',

    REGISTER_BUSINESS = '@@business/REGISTER_BUSINESS',
    REGISTER_BUSINESS_SUCCESS = '@@business/REGISTER_BUSINESS_SUCCESS',
    REGISTER_BUSINESS_ERROR = '@@business/REGISTER_BUSINESS_ERROR',

    RESET = '@@business/RESET',

    LANGUAGE_LIST = '@@language/LANGUAGE_LIST',
    LANGUAGE_LIST_SUCCESS = '@@language/LANGUAGE_LIST_SUCCESS',
    LANGUAGE_LIST_ERROR = '@@language/LANGUAGE_LIST_ERROR',

    UPDATE_BUSINESS_LIST = '@@business/UPDATE_BUSINESS_LIST',
    UPDATE_BUSINESS_LIST_SUCCESS = '@@business/UPDATE_BUSINESS_LIST_SUCCESS',
    UPDATE_BUSINESS_LIST_ERROR = '@@business/UPDATE_BUSINESS_LIST_ERROR',

    DELETE_BUSINESS_LIST = '@@business/DELETE_BUSINESS_LIST',
    DELETE_BUSINESS_LIST_SUCCESS = '@@business/DELETE_BUSINESS_LIST_SUCCESS',
    DELETE_BUSINESS_LIST_ERROR = '@@business/DELETE_BUSINESS_LIST_ERROR',

    REGISTER_OUTLET = '@@business/REGISTER_OUTLET',
    REGISTER_OUTLET_SUCCESS = '@@business/REGISTER_OUTLET_SUCCESS',
    REGISTER_OUTLET_ERROR = '@@business/REGISTER_OUTLET_ERROR',

    UPDATE_OUTLET = '@@business/UPDATE_OUTLET',
    UPDATE_OUTLET_SUCCESS = '@@business/UPDATE_OUTLET_SUCCESS',
    UPDATE_OUTLET_ERROR = '@@business/UPDATE_OUTLET_ERROR',

    DELETE_OUTLET = '@@business/DELETE_OUTLET',
    DELETE_OUTLET_SUCCESS = '@@business/DELETE_OUTLET_SUCCESS',
    DELETE_OUTLET_ERROR = '@@business/DELETE_OUTLET_ERROR',

    REGISTER_BUSINESS_USER = '@@business/REGISTER_BUSINESS_USER',
    REGISTER_BUSINESS_USER_SUCCESS = '@@business/REGISTER_BUSINESS_USER_SUCCESS',
    REGISTER_BUSINESS_USER_ERROR = '@@business/REGISTER_BUSINESS_USER_ERROR',

    UPDATE_BUSINESS_USER = '@@business/UPDATE_BUSINESS_USER',
    UPDATE_BUSINESS_USER_SUCCESS = '@@business/UPDATE_BUSINESS_USER_SUCCESS',
    UPDATE_BUSINESS_USER_ERROR = '@@business/UPDATE_BUSINESS_USER_ERROR',

    DELETE_BUSINESS_USER = '@@business/DELETE_BUSINESS_USER',
    DELETE_BUSINESS_USER_SUCCESS = '@@business/DELETE_BUSINESS_USER_SUCCESS',
    DELETE_BUSINESS_USER_ERROR = '@@business/DELETE_BUSINESS_USER_ERROR',

    BUSINESS_UPDATE_ISACTIVE = '@@business/BUSINESS_UPDATE_ISACTIVE',
    BUSINESS_UPDATE_ISACTIVE_SUCCESS = '@@business/BUSINESS_UPDATE_ISACTIVE_SUCCESS',
    BUSINESS_UPDATE_ISACTIVE_ERROR = '@@business/BUSINESS_UPDATE_ISACTIVE_ERROR',

    OUTLET_UPDATE_ISACTIVE = '@@business/BUSINESS_UPDATE_ISACTIVE',
    OUTLET_UPDATE_ISACTIVE_SUCCESS = '@@business/OUTLET_UPDATE_ISACTIVE_SUCCESS',
    OUTLET_UPDATE_ISACTIVE_ERROR = '@@business/OUTLET_UPDATE_ISACTIVE_ERROR',

    BUSINESS_DETAILS = '@@business/BUSINESS_DETAILS',
    BUSINESS_DETAILS_SUCCESS = '@@business/BUSINESS_DETAILS_SUCCESS',
    BUSINESS_DETAILS_ERROR = '@@business/BUSINESS_DETAILS_ERROR',
}
